import { Injectable } from '@angular/core';
import { ContainersService } from 'src/app/shared/services/containers.service';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/shared/services/app-config';

@Injectable()
export class ContainerService extends ContainersService {

  constructor(http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  public getResourceUrl(): string {
    return `${this.baseUrl}containers/`;
  }
}